const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
export const isImage = (extension: string) => imageExtensions.includes(extension.toLowerCase());
